import moment from 'moment';

// What the is_content_item_mixin getters showed for modified_at and published_at. The timestamps
// arrive as epoch seconds, and the format string matches the amDateFormat filter the Angular panel
// used. 'Unknown' is the mixin's fallback, localized under content_item.is_content_item_mixin, but
// the course editor is editor-only and renders in English.
export const UNKNOWN_DATE = 'Unknown';

export function formatContentItemDate(timestamp: number | null | undefined): string {
    if (!timestamp) return UNKNOWN_DATE;
    return moment(new Date(timestamp * 1000)).format('l h:mm:ss a');
}
